<template>
    <v-container grid-list-xs fluid>
        <v-card>
            <v-toolbar dark color="secondary" dense>
                <v-spacer />
                <v-toolbar-title class="white--text">Eleos</v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-container grid-list-xs>
                <v-form ref="form" lazy-validation class="mb-2">
                    <v-row justify="center">
                        <v-btn icon color="secondary" @click="restDay()"  class="mt-3 mr-2"><v-icon>mdi-page-previous</v-icon></v-btn>
                        <v-col cols="2">
                            <v-text-field
                                label="Start Date"
                                id="StartDate"
                                :value="StartDate"
                                :placeholder="$store.state.placeholder"
                                v-mask="$store.state.mask"
                                :rules="$store.state.dateRules"
                                dense
                                hide-details
                                required
                            ></v-text-field>
                        </v-col>
                        <v-col cols="2">
                            <v-text-field
                                label="End Date"
                                id="EndDate"
                                :value="EndDate"
                                :placeholder="$store.state.placeholder"
                                v-mask="$store.state.mask"
                                :rules="$store.state.dateRules"
                                dense
                                hide-details
                                required
                            ></v-text-field>
                        </v-col>
                        <v-btn icon color="secondary" @click="addDay()"  class="mt-3 ml-2"><v-icon>mdi-page-next</v-icon></v-btn>

                        <v-btn
                            color="primary"
                            small
                            class="my-auto ml-2"
                            @click="getShiftCheck"
                            >Search</v-btn
                        >
                        <v-btn
                            color="primary"
                            small
                            class=" my-auto ml-2"
                            v-if="ShiftDetails.length > 0"
                            @click="postingShift"
                            ><v-icon class="mr-1" >mdi-post</v-icon> Posting</v-btn
                        >
                    </v-row>
                </v-form>
            </v-container>
            <v-container grid-list-xs fluid v-if="ShiftDetails.length > 0">
                <v-toolbar dense>
                    <v-combobox
                            label="Filter By Driver"
                            dense
                            :items="Drivers"
                            auto-select-first
                            v-model="driverFilter"
                            @change="selectDriver"
                        ></v-combobox>
                        <v-spacer></v-spacer>
                        <div>
                            <v-btn
                            @click="openPpWEmail(2)"
                            dark
                            color="#FFC107"
                            icon
                            class="mr-12"
                            ><v-icon>mdi-card-account-mail</v-icon> Send
                            Mail</v-btn
                            >
                            <v-btn
                                @click="openPpWEmail(3)"
                                dark
                                color="#B71C1C"
                                icon
                                class="ml-12"
                                ><v-icon>mdi-card-account-mail</v-icon> Send
                                Mail</v-btn
                            >
                        </div>
                        <v-spacer></v-spacer>
                        <v-spacer></v-spacer>
                        <v-spacer></v-spacer>
                        <v-simple-table dense>
                            <tr>
                                <td>
                                    <v-icon
                                    @click="
                                            filterByColor(null)
                                        "
                                            >mdi-circle</v-icon
                                        > Clean
                                </td>
                                <template v-for="(cls, idx) in colors">
                                    <!-- @click="openPpWEmail(cls)" -->
                                    <td
                                        v-bind:key="'cls' + idx"
                                        @click="
                                            filterByColor(cls.BolCheckStatusID)
                                        "
                                    >
                                        <v-icon :color="cls.Status"
                                            >mdi-circle</v-icon
                                        >
                                        {{ cls.Total }}
                                    </td>
                                </template>
                            </tr>
                        </v-simple-table>
                </v-toolbar>
                <v-data-iterator
                    :items="filteredItems"
                    :page="page"
                    :items-per-page="1"
                    hide-default-footer
                >
                    <template v-slot:default="props">
                        <v-card
                            v-for="(shift, idx) in props.items"
                            v-bind:key="'Dsp' + idx"
                            style="min-height: 70vh"
                        >
                            <v-toolbar color="primary" dense dark>
                                <table class="tableEloesCheck">
                                    <tr>
                                        <td class="text-left"><b>Date</b></td>
                                        <td class="text-left">
                                            <b>ShiftDetail</b>
                                        </td>
                                        <td class="text-left"><b>Driver</b></td>
                                        <td class="text-left"><b>Truck</b></td>
                                        <td class="text-left">
                                            <b>Trailer</b>
                                        </td>
                                        <td class="text-left">
                                            <b>NumAxles</b>
                                        </td>
                                        <td class="text-left"><b>Yard</b></td>
                                        <td class="text-left"><b>OdoStart</b></td>
                                        <td class="text-left"><b>OdoEnd</b></td>
                                        <td class="text-left"><b>Total</b></td>
                                        <td class="text-left"><b>GPSShiftStart</b></td>
                                        <td class="text-left"><b>GPSShiftEnd</b></td>
                                        <td class="text-left"><b>GPSTotal</b></td>
                                        <td class="text-left"><b>LogStart</b></td>
                                        <td class="text-left"><b>LogEnd</b></td>
                                        <td class="text-left"><b>LogTotal</b></td>
                                        <td class="text-left">
                                            <b>Daily Summary</b>
                                        </td>
                                        <td>Finalize</td>
                                        <td
                                            class="text-center"
                                            v-if="filteredItems.length == 1"
                                        >
                                            Recalculate Hrs
                                        </td>
                                        <td>Change</td>
                                    </tr>
                                    <tr>
                                        <td class="text-left">
                                            {{ shift.Date + ' ' + shift.Shift }}
                                        </td>
                                        <td class="text-left">
                                            {{ shift.ShiftDetail }}
                                        </td>
                                        <td class="text-left">
                                            {{ shift.Driver }}
                                        </td>
                                        <td class="text-left">
                                            {{ shift.Truck }}
                                        </td>
                                        <td class="text-left">
                                            {{ shift.Trailer }}
                                        </td>
                                        <td class="text-left">
                                            {{ shift.NumAxles }}
                                        </td>
                                        <td class="text-left">
                                            {{ shift.Yard }}
                                        </td>
                                        <td class="text-left">
                                            {{ shift.OdoStart }}
                                        </td>
                                        <td class="text-left">
                                            {{ shift.OdoEnd }}
                                        </td>
                                        <td class="text-left">
                                            {{ shift.OdoTotal }}
                                        </td>
                                        <td class="text-left">
                                            <p 
                                                class="float-left"
                                                :style="
                                                    shift.GPSShiftStartOrigin == 2 ? 
                                                    'margin: 0;padding: 0;background-color: #80D8A6;color: #000;' :
                                                    shift.GPSShiftStartOrigin == 3 ? 
                                                    'margin: 0;padding: 0;background-color: #80D8D5;color: #000;' :
                                                    shift.GPSShiftStartOrigin == 4 ? 
                                                    'margin: 0;padding: 0;background-color: #eff93f;color: #000;' : 
                                                    'margin: 0;padding: 0;'
                                                    "
                                                >
                                                    {{ shift.GPSShiftStartDate }}
                                                    <strong
                                                        class="timeLoadValue"
                                                    >
                                                        {{ shift.GPSShiftStartTime }}
                                                    </strong>
                                                </p>
                                        </td>
                                        <td class="text-left">
                                            <p 
                                                class="float-left"
                                                :style="
                                                    shift.GPSShiftEndOrigin == 2 ? 
                                                    'margin: 0;padding: 0;background-color: #80D8A6;color: #000;' :
                                                    shift.GPSShiftEndOrigin == 3 ? 
                                                    'margin: 0;padding: 0;background-color: #80D8D5;color: #000;' :
                                                    shift.GPSShiftEndOrigin == 4 ? 
                                                    'margin: 0;padding: 0;background-color: #eff93f;color: #000;' : 
                                                    'margin: 0;padding: 0;'
                                                    "
                                                >
                                                    {{ shift.GPSShiftEndDate }}
                                                    <strong
                                                        class="timeLoadValue"
                                                    >
                                                        {{ shift.GPSShiftEndTime }}
                                                    </strong>
                                                </p>
                                        </td>
                                        <td class="text-left">
                                            {{ shift.GPSTotal }}
                                        </td>
                                        <td class="text-left">
                                            <p 
                                                class="float-left"
                                                :style="
                                                    shift.LogStartOrigin == 2 ? 
                                                    'margin: 0;padding: 0;background-color: #80D8A6;color: #000;' :
                                                    shift.LogStartOrigin == 3 ? 
                                                    'margin: 0;padding: 0;background-color: #80D8D5;color: #000;' :
                                                    shift.LogStartOrigin == 4 ? 
                                                    'margin: 0;padding: 0;background-color: #eff93f;color: #000;' : 
                                                    'margin: 0;padding: 0;'
                                                    "
                                                >
                                                    {{ shift.LogStartDate }}
                                                    <strong
                                                        class="timeLoadValue"
                                                    >
                                                        {{ shift.LogStartTime }}
                                                    </strong>
                                                </p>
                                        </td>
                                        <td class="text-left">
                                            <p 
                                                class="float-left"
                                                :style="
                                                    shift.LogEndOrigin == 2 ? 
                                                    'margin: 0;padding: 0;background-color: #80D8A6;color: #000;' :
                                                    shift.LogEndOrigin == 3 ? 
                                                    'margin: 0;padding: 0;background-color: #80D8D5;color: #000;' :
                                                    shift.LogEndOrigin == 4 ? 
                                                    'margin: 0;padding: 0;background-color: #eff93f;color: #000;' : 
                                                    'margin: 0;padding: 0;'
                                                    "
                                                >
                                                    {{ shift.LogEndDate }}
                                                    <strong
                                                        class="timeLoadValue"
                                                    >
                                                        {{ shift.LogEndTime }}
                                                    </strong>
                                                </p>
                                        </td>
                                        <td class="text-left">
                                            {{ shift.LogTotal }}
                                        </td>

                                        <td>
                                            <v-icon
                                                color="white"
                                                @click="getDailySummary(shift)"
                                            >
                                                mdi-newspaper-variant-outline
                                            </v-icon>
                                        </td>
                                        <td>
                                            <v-icon
                                                color="white"
                                                @click="fnShiftConfirm(shift)"
                                                >mdi-lock-check</v-icon
                                            >
                                        </td>

                                        <td
                                            class="text-center"
                                            v-if="filteredItems.length == 1"
                                        >
                                            <v-icon
                                                color="white"
                                                @click="fnShiftConfirm(shift)"
                                                >mdi-refresh</v-icon
                                            >
                                        </td>
                                        <td>
                                            <v-icon @click="confirmChange(shift)">mdi-swap-horizontal</v-icon>
                                        </td>
                                    </tr>
                                </table>
                            </v-toolbar>
                            <v-container grid-list-xs fluid>
                                <v-simple-table dense>
                                    <thead>
                                        <tr>
                                            <th>Actions</th>
                                            <th>Status</th>
                                            <th>OrderStatus</th>
                                            <th>OrderID</th>
                                            <th>Terminal</th>
                                            <th>Station</th>
                                            <th>L1</th>
                                            <th>L2</th>
                                            <th>BOLNumber</th>
                                            <th colspan="5">Reason</th>
                                        </tr>
                                    </thead>
                                    <tbody
                                        v-for="(ords, i) in shift.orders"
                                        v-bind:key="'ords' + i"
                                    >
                                        <tr
                                            @contextmenu.prevent="
                                                $refs.viewOrder.open(
                                                    $event,
                                                    ords
                                                )
                                            "
                                        >
                                            <td>
                                                <v-btn
                                                    icon
                                                    color="primary"
                                                    @click="
                                                        openPaperworkAnalyticsPanel(
                                                            shift.orders,
                                                            i
                                                        )
                                                    "
                                                >
                                                    <v-icon>
                                                        mdi-file-find
                                                    </v-icon>
                                                </v-btn>
                                            </td>
                                            <td>
                                                <v-icon :color="ords.Status">
                                                    mdi-circle
                                                </v-icon>
                                            </td>
                                            <td>{{ ords.OrderStatus }}</td>
                                            <td @click="openModal(ords)">
                                                {{ ords.OrderID }}
                                            </td>
                                            <td>{{ ords.Terminal }}</td>
                                            <td>{{ ords.Station }}</td>
                                            <td>{{ ords.LoadNum }}</td>
                                            <td>{{ ords.LoadNumOrd }}</td>
                                            <td colspan="5">
                                                {{ ords.ReasonForChange }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <th
                                                style="background: #fff;"
                                                colspan="2"
                                            ></th>
                                            <th>Terminal Start</th>
                                            <th>Terminal End</th>
                                            <th>Station Start</th>
                                            <th>Station End</th>
                                            <th class="text-center">
                                                BOLNumber
                                            </th>
                                            <th class="text-center">Product</th>
                                            <th class="text-center">
                                                PlannedAmount
                                            </th>
                                            <th class="text-center">
                                                Gross Qty
                                            </th>
                                            <th class="text-center">Net Qty</th>
                                        </tr>

                                        <template v-if="ords.eleos_data.length">
                                            <tr
                                                v-for="(prd,
                                                index) in ords.eleos_data"
                                                v-bind:key="'prd' + index"
                                            >
                                                <td
                                                    style="background: #fff;"
                                                    v-if="index < 1"
                                                    colspan="2"
                                                ></td>
                                                <td v-if="index < 1">
                                                    <p
                                                        :style="
                                                            ords.TStartOrigin ==
                                                            2
                                                                ? 'margin: 0;padding: 2px 0 0;width: 140px;background-color: #80D8A6;'
                                                                : ords.TStartOrigin ==
                                                                  3
                                                                ? 'margin: 0;padding: 2px 0 0;width: 140px;background-color: #80D8D5;'
                                                                : ords.TStartOrigin ==
                                                                  4
                                                                ? 'margin: 0;padding: 2px 0 0;width: 140px;background-color: #eff93f;'
                                                                : 'margin: 0;padding: 2px 0 0;width: 140px;'
                                                        "
                                                    >
                                                        {{ ords.TStart }}
                                                        <strong
                                                            class="timeLoadValue"
                                                        >
                                                            {{
                                                                ords.TStartTime
                                                            }}
                                                        </strong>
                                                    </p>
                                                </td>
                                                <td v-if="index < 1">
                                                    <p
                                                        :style="
                                                            ords.TEndOrigin == 2
                                                                ? 'margin: 0;padding: 2px 0 0;width: 140px;background-color: #80D8A6;'
                                                                : ords.TEndOrigin ==
                                                                  3
                                                                ? 'margin: 0;padding: 2px 0 0;width: 140px;background-color: #80D8D5;'
                                                                : ords.TEndOrigin ==
                                                                  4
                                                                ? 'margin: 0;padding: 2px 0 0;width: 140px;background-color: #eff93f;'
                                                                : 'margin: 0;padding: 2px 0 0;width: 140px;'
                                                        "
                                                    >
                                                        {{ ords.TEnd }}
                                                        <strong
                                                            class="timeLoadValue"
                                                        >
                                                            {{ ords.TEndTime }}
                                                        </strong>
                                                    </p>
                                                </td>
                                                <td v-if="index < 1">
                                                    <p
                                                        :style="
                                                            ords.StStartOrigin ==
                                                            2
                                                                ? 'margin: 0;padding: 2px 0 0;width: 140px;background-color: #80D8A6;'
                                                                : ords.StStartOrigin ==
                                                                  3
                                                                ? 'margin: 0;padding: 2px 0 0;width: 140px;background-color: #80D8D5;'
                                                                : ords.StStartOrigin ==
                                                                  4
                                                                ? 'margin: 0;padding: 2px 0 0;width: 140px;background-color: #eff93f;'
                                                                : 'margin: 0;padding: 2px 0 0;width: 140px;'
                                                        "
                                                    >
                                                        {{ ords.StStart }}
                                                        <strong
                                                            class="timeLoadValue"
                                                        >
                                                            {{
                                                                ords.StStartTime
                                                            }}
                                                        </strong>
                                                    </p>
                                                </td>
                                                <td v-if="index < 1">
                                                    <p
                                                        :style="
                                                            ords.StEndOrigin ==
                                                            2
                                                                ? 'margin: 0;padding: 2px 0 0;width: 140px;background-color: #80D8A6;'
                                                                : ords.StEndOrigin ==
                                                                  3
                                                                ? 'margin: 0;padding: 2px 0 0;width: 140px;background-color: #80D8D5;'
                                                                : ords.StEndOrigin ==
                                                                  4
                                                                ? 'margin: 0;padding: 2px 0 0;width: 140px;background-color: #eff93f;'
                                                                : 'margin: 0;padding: 2px 0 0;width: 140px;'
                                                        "
                                                    >
                                                        {{ ords.StEnd }}
                                                        <strong
                                                            class="timeLoadValue"
                                                        >
                                                            {{ ords.StEndTime }}
                                                        </strong>
                                                    </p>
                                                </td>
                                                <td
                                                    style="background: #fff;"
                                                    v-if="index >= 1"
                                                    colspan="6"
                                                ></td>
                                                <td style="background: #fff;">
                                                    {{ prd.BOLNumber }}
                                                </td>
                                                <td
                                                    style="background: #fff;"
                                                    class="text-center"
                                                >
                                                    {{ prd.Product }}
                                                </td>
                                                <td
                                                    style="background: #fff;"
                                                    class="text-center"
                                                >
                                                    {{ prd.PlannedAmount }}
                                                </td>
                                                <td
                                                    style="background: #fff;color:red;"
                                                    class="text-center"
                                                    v-if="
                                                        prd.DiffGross < 0.05 &&
                                                            prd.DiffGross > 0
                                                    "
                                                >
                                                    {{ prd.GrossQuantity }}
                                                </td>
                                                <td
                                                    style="background: #fff;"
                                                    class="text-center"
                                                    v-else
                                                >
                                                    {{ prd.GrossQuantity }}
                                                </td>
                                                <td
                                                    style="background: #fff;color:red;"
                                                    class="text-center"
                                                    v-if="
                                                        prd.DiffNet < 0.05 &&
                                                            prd.DiffNet > 0
                                                    "
                                                >
                                                    {{ prd.NetQuantity }}
                                                </td>
                                                <td
                                                    style="background: #fff;"
                                                    class="text-center"
                                                    v-else
                                                >
                                                    {{ prd.NetQuantity }}
                                                </td>
                                            </tr>
                                        </template>
                                        <template v-else>
                                            <td
                                                style="background: #fff;"
                                                colspan="2"
                                            ></td>
                                            <td>
                                                <p
                                                    :style="
                                                        ords.TStartOrigin == 2
                                                            ? 'margin: 0;padding: 2px 0 0;width: 140px;background-color: #80D8A6;'
                                                            : ords.TStartOrigin ==
                                                              3
                                                            ? 'margin: 0;padding: 2px 0 0;width: 140px;background-color: #80D8D5;'
                                                            : ords.TStartOrigin ==
                                                              4
                                                            ? 'margin: 0;padding: 2px 0 0;width: 140px;background-color: #eff93f;'
                                                            : 'margin: 0;padding: 2px 0 0;width: 140px;'
                                                    "
                                                >
                                                    {{ ords.TStart }}
                                                    <strong
                                                        class="timeLoadValue"
                                                    >
                                                        {{ ords.TStartTime }}
                                                    </strong>
                                                </p>
                                            </td>
                                            <td>
                                                <p
                                                    :style="
                                                        ords.TEndOrigin == 2
                                                            ? 'margin: 0;padding: 2px 0 0;width: 140px;background-color: #80D8A6;'
                                                            : ords.TEndOrigin ==
                                                              3
                                                            ? 'margin: 0;padding: 2px 0 0;width: 140px;background-color: #80D8D5;'
                                                            : ords.TEndOrigin ==
                                                              4
                                                            ? 'margin: 0;padding: 2px 0 0;width: 140px;background-color: #eff93f;'
                                                            : 'margin: 0;padding: 2px 0 0;width: 140px;'
                                                    "
                                                >
                                                    {{ ords.TEnd }}
                                                    <strong
                                                        class="timeLoadValue"
                                                    >
                                                        {{ ords.TEndTime }}
                                                    </strong>
                                                </p>
                                            </td>
                                            <td>
                                                <p
                                                    :style="
                                                        ords.StStartOrigin == 2
                                                            ? 'margin: 0;padding: 2px 0 0;width: 140px;background-color: #80D8A6;'
                                                            : ords.StStartOrigin ==
                                                              3
                                                            ? 'margin: 0;padding: 2px 0 0;width: 140px;background-color: #80D8D5;'
                                                            : ords.StStartOrigin ==
                                                              4
                                                            ? 'margin: 0;padding: 2px 0 0;width: 140px;background-color: #eff93f;'
                                                            : 'margin: 0;padding: 2px 0 0;width: 140px;'
                                                    "
                                                >
                                                    {{ ords.StStart }}
                                                    <strong
                                                        class="timeLoadValue"
                                                    >
                                                        {{ ords.StStartTime }}
                                                    </strong>
                                                </p>
                                            </td>
                                            <td>
                                                <p
                                                    :style="
                                                        ords.StEndOrigin == 2
                                                            ? 'margin: 0;padding: 2px 0 0;width: 140px;background-color: #80D8A6;'
                                                            : ords.StEndOrigin ==
                                                              3
                                                            ? 'margin: 0;padding: 2px 0 0;width: 140px;background-color: #80D8D5;'
                                                            : ords.StEndOrigin ==
                                                              4
                                                            ? 'margin: 0;padding: 2px 0 0;width: 140px;background-color: #eff93f;'
                                                            : 'margin: 0;padding: 2px 0 0;width: 140px;'
                                                    "
                                                >
                                                    {{ ords.StEnd }}
                                                    <strong
                                                        class="timeLoadValue"
                                                    >
                                                        {{ ords.StEndTime }}
                                                    </strong>
                                                </p>
                                            </td>
                                            <td
                                                style="background: #fff;"
                                                colspan="6"
                                            ></td>
                                        </template>
                                    </tbody>
                                </v-simple-table>
                            </v-container>
                        </v-card>
                    </template>
                </v-data-iterator>
                <v-row justify="end">
                    <v-col cols="1">
                        <v-btn color="primary" large icon @click="prevPage"
                            ><v-icon
                                >mdi-arrow-left-drop-circle-outline</v-icon
                            ></v-btn
                        >
                        {{ page + '-' + filteredItems.length }}
                        <v-btn color="primary" large icon @click="nextPage"
                            ><v-icon
                                >mdi-arrow-right-drop-circle-outline</v-icon
                            ></v-btn
                        >
                    </v-col>
                </v-row>
                <v-dialog
                    v-model="$store.state.posting.dialog"
                    max-width="1366px"
                    transition="dialog-transition"
                >
                    <OrderData
                        v-if="$store.state.posting.dialog"
                        :parms="params"
                    />
                </v-dialog>
            </v-container>
        </v-card>
        <vue-context ref="viewOrder">
            <template slot-scope="selected" v-if="selected.data">
                <li>
                    <a @click="openModalOrder(selected.data.OrderID)"
                        >View Order</a
                    >
                </li>
            </template>
        </vue-context>
        <editOrder
            ref="ordersref"
            isModal="true"
            v-if="$store.state.order.edt"
        ></editOrder>

        <ShiftDataViewer
            v-if="showPaperworkAnalyticsPanel"
            :OrderToCheck="OrderToCheck"
            :FromEleosCheck="fromEleosCheck"
            :pageIndex="pageIndex"
            :showPaperworkAnalyticsPanel="showPaperworkAnalyticsPanel"
            @close="getOrdersColor"
            @closeModal="closeModal"
        >
        </ShiftDataViewer>
        <DailySummary
            v-if="$store.state.paperworkAnalytics.DailySummay"
            :OrderToCheck="DailySum"
            :Shift:="shift"
        ></DailySummary>
        <ppwEmail
            v-if="$store.state.paperworkAnalytics.PpwEmail"
            :parms="parms"
        ></ppwEmail>

        <checkDemurrage
            v-if="$store.state.eleos.demurrage"
            :demurrage="newdemurrage"
            @closeDmr="checkNewDemurrages()"
        >
        </checkDemurrage>
        <pending v-if="$store.state.eleos.pending" :pending="pending"></pending>
        <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
    </v-container>
</template>
<script>
import mmt from 'moment';
import axios from 'axios';
import ConfirmDialogue from './../Modals/ConfirmDialogue.vue';
import OrderData from './../Modals/Administration/OrderEdit.vue';
import checkDemurrage from './../Modals/Administration/Demurrage/CheckDemurrage.vue';
import pending from './../Modals/Administration/Demurrage/PendingDemurrage.vue';
import { mask } from 'vue-the-mask';
import VueContext from 'vue-context';
import editOrder from './../Modals/Dispatch/Orders/EditOrder.vue';
import ppwEmail from './../Paperwork/PpwEmail.vue';
import ShiftDataViewer from '../Paperwork/ShiftDataViewer.vue';
import DailySummary from '../Paperwork/DailySummary.vue';
export default {
    components: {
        OrderData,
        VueContext,
        editOrder,
        ShiftDataViewer,
        DailySummary,
        ppwEmail,
        ConfirmDialogue,
        checkDemurrage,
        pending
    },
    directives: { mask },
    data: function() {
        return {
            parms: {},
            newdemurrage: [],
            StartDate: '',
            Drivers: [],
            EndDate: '',
            driverFilter: '',
            colors: [],
            ShiftDetails: [],
            shift: [],
            typeColor: null,
            pending: null,
            page: 1,
            pageIndex: null,
            actions: [],
            DailySum: [],
            showPaperworkAnalyticsPanel: false,
            headers: [
                // { text: 'ShiftDetail', value: 'ShiftDetail', width: '1%' },
                { text: 'Status', value: 'OrderStatus', width: '1%' },
                { text: 'Order', value: 'OrderID', width: '1%' },
                { text: 'Terminal', value: 'Terminal', width: '20%' },
                { text: 'Station', value: 'Station', width: '20%' },
                { text: 'LoadNum', value: 'LoadNum', width: '1%' },
                { text: 'NumOrd', value: 'LoadNumOrd', width: '1%' },
                { text: 'BOLNumber', value: 'BOLNumber', width: '1%' },
                { text: 'Product', value: 'Product', width: '1%' },
                { text: 'PlannedAmount', value: 'PlannedAmount', width: '1%' },
                { text: 'Gross Qty', value: 'GrossQuantity', width: '1%' },
                { text: 'Net Qty', value: 'NetQuantity', width: '1%' },
                {
                    text: 'Forcing reason',
                    value: 'ReasonForChange',
                    width: '10%'
                }
            ],
            specificOrderNotReviewed: [],
            OrderToCheck: [],
            fromEleosCheck: true
        };
    },
    computed: {
        filteredItems: function() {
            return this.ShiftDetails.filter(i => {
                return !this.driverFilter || i.Driver == this.driverFilter;
            });
        }
    },
    mounted() {
        // this.getAllPendings();
        this.getActions();
        if (
            this.$store.state.roles == 'Admin � QC Senior' ||
            this.$store.state.roles == 'Admin � QC Junior' ||
            this.$store.state.roles == 'Administrator' ||
            this.$store.state.roles == 'Admin � Payroll Owners' ||
            this.$store.state.roles == 'Admin � Invoice Junior' ||
            this.$store.state.roles == 'Admin � Supervisor' ||
            this.$store.state.roles == 'IT Master'
        ) {
            this.timer = setInterval(() => {
                //  Call the function that checks demurrages
                console.log(
                    'Checking for new demurrages: ' +
                        this.$store.state.eleos.demurrage
                );
                if (this.$store.state.eleos.demurrage == false) {
                    this.checkNewDemurrages();
                }
            }, 1000 * 900);
        } else {
            this.$store.dispatch('setSnackbar', {
                color: 'error',
                time: 10000,
                text:
                    'You do not have the permission to use this function.' +
                    this.$store.state.roles
            });
        }
    },
    methods: {
        wait: function(ms) {
            return new Promise(resolve => setTimeout(resolve, ms));
        },
        addDay:async function (){
            try  {
                const start = mmt(this.$store.state.getMsk('StartDate'));
                let newStart =  start.add(24, 'hours');
                this.StartDate =  newStart.format('YYYY-MM-DD');

                const end   =  mmt(this.$store.state.getMsk('EndDate'));
                let newEnd = end.add(24, 'hours');
                this.EndDate =  newEnd.format('YYYY-MM-DD');
                await this.wait(500);
                this.getShiftCheck();
            }catch(error){
                console.log(error);
            }
            
        },
        restDay:async function(){
            
            const start = mmt(this.$store.state.getMsk('StartDate'));
            let newStart = start.subtract(24, 'hours');
            this.StartDate =  newStart.format('YYYY-MM-DD');

            const end   = mmt(this.$store.state.getMsk('EndDate'));
            let newEnd = end.subtract(24, 'hours');
            this.EndDate =  newEnd.format('YYYY-MM-DD');
            
            await this.wait(500);
                this.getShiftCheck();
        },
        async confirmChange(item) {
            const act = item.Shift == 'PM' ? 'AM': 'PM';
            const ok = await this.$refs.confirmDialogue.show({
                title:'You are about to change this driver to shift '+ item.Date + ' ' + act,
                message: 'Are you sure?',
                okButton: 'Yes',
                cancelButton: 'No'
            });
            // If you throw an error, the method will terminate here unless you surround it wil try/catch
            if (ok) {
                this.chageShift(item);
            }
        },
        chageShift: function(item){
            var parms = {};
            if(item.Shift == "PM"){
                parms.ShiftHeaderNum = item.ShiftHeaderNum -1;
            }else{
                parms.ShiftHeaderNum = item.ShiftHeaderNum +1;
            }
             axios
                .put('shift-detail/' + item.ShiftDetail, parms, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {

                    this.getShiftCheck();
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        nextPage: function() {
            if (this.page < this.filteredItems.length) {
                this.page++;
                this.updateShiftHrs(this.filteredItems[this.page - 1]);
                console.log(this.page);
            }
        },
        prevPage: function() {
            if (this.page > 1) {
                this.page--;
                this.updateShiftHrs(this.filteredItems[this.page - 1]);
                console.log(this.page);
            }
        },
        updateShiftHrs: async function(shiftDetails) {
            console.log(shiftDetails);
            await axios
                .post(
                    'order/recalculateTimes/' + shiftDetails.ShiftDetail,
                    {},
                    {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    }
                )
                .then(response => {
                    console.log('Here', response.data);
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        filterdColor: async function() {
            return this.ShiftDetails.filter(async i => {
                var isExist = await i.orders.findIndex(x => {
                    if (x.BolCheckStatusID == this.typeColor) {
                        return true;
                    }
                });
                if (isExist) {
                    console.log(isExist);
                    return i;
                }
            });
        },
        filterByColor: function(itm) {
            this.typeColor = itm;
            this.getShiftCheck();
            console.log(this.typeColor);
        },
        getAllPendings: function() {
            var str = this.$store;
            axios
                .get('demurrage-check/pending')
                .then(response => {
                    this.pending = response.data;
                })
                .catch(function(error) {
                    console.log(error);
                    str.dispatch('setSnackbar', {
                        color: 'error',
                        text:
                            'Something is wrong. Please contact the administrator.'
                    });
                });
        },
        checkNewDemurrages() {
            var str = this.$store;
            axios
                .get('demurrage-check/demurrage')
                .then(response => {
                    this.newdemurrage = response.data;
                    if (this.newdemurrage.length != []) {
                        this.$store.state.eleos.demurrage = true;
                    }
                    console.log(response.data);
                })
                .catch(function(error) {
                    console.log(error);
                    str.dispatch('setSnackbar', {
                        color: 'error',
                        text:
                            'Something is wrong. Please contact the administrator.'
                    });
                });
        },
        async fnShiftConfirm(itm) {
            const ok = await this.$refs.confirmDialogue.show({
                title: '',
                message: 'Are you sure?',
                okButton: 'Yes',
                cancelButton: 'No'
            });
            // If you throw an error, the method will terminate here unless you surround it wil try/catch
            if (ok) {
                this.FinalizeShift(itm);
            }
        },
        FinalizeShift: function(itm) {
            var parms = {
                DispatchFinalize: 1
            };
            var str = this.$store;
            axios
                .put('shift-detail/' + itm.ShiftDetail, parms)
                .then(response => {
                    console.log(response.data);
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Shift Successfully completed'
                    });
                })
                .catch(error => {
                    console.log(error);
                    str.state.isLoading = false;
                    str.dispatch('setSnackbar', {
                        color: 'error',
                        text:
                            'Something is wrong. Please contact the administrator.'
                    });
                });
        },
        selectDriver: function() {
            console.log(this.driverFilter);
        },
        eliminarDuplicados: function(arr) {
            const uniqueElements = new Set();
            return arr.filter(item => {
                const serializedItem = JSON.stringify(item);
                if (!uniqueElements.has(serializedItem)) {
                    uniqueElements.add(serializedItem);
                    return true;
                }
                return false;
            });
        },
        openModalOrder(orderID) {
            console.log('The order id is:' + orderID);
            this.$store.state.editedOrder.id = orderID;
            this.$store.state.editedOrder.destiny = 1;
            this.$store.state.order.edt = true;
        },
        openModal(itm) {
            this.$store.state.orderInfo.orderId = itm.OrderID;
            this.$store.state.posting.dialog = true;
        },
        getActions: function() {
            var str = this.$store;
            axios
                .get('action/active')
                .then(response => {
                    this.actions = response.data;
                })
                .catch(function(error) {
                    console.log(error);
                    str.state.isLoading = false;
                    str.dispatch('setSnackbar', {
                        color: 'error',
                        text:
                            'Something is wrong. Please contact the administrator.'
                    });
                });
        },
        getDailySummary: function(shift) {
            console.log(shift);
            var str = this.$store;
            axios
                .get('order/document/daily-summary/' + shift.ShiftDetail)
                .then(async response => {
                    this.shift = shift;
                    this.DailySum = response.data;
                    console.log(this.DailySum);
                    if (this.DailySum.length > 0) {
                        var isDls = null;
                        await this.shift.orders.forEach(async element => {
                            isDls = await element.actions.findIndex(x => {
                                return x.Action == 'RP - Missing Daily Summary';
                            });

                            if (isDls >= 0) {
                                return false;
                            }
                        });
                        console.log(isDls);
                        if (isDls >= 0) {
                            this.lessActionMissingDls(shift);
                        } else {
                            this.$store.state.paperworkAnalytics.DailySummay = true;
                        }
                    } else {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'DailySummary not found.'
                        });
                        if (this.DailySum) {
                            this.setMissingDlsAction(shift);
                        }
                    }
                })
                .catch(function(error) {
                    console.log(error);
                    str.state.isLoading = false;
                    str.dispatch('setSnackbar', {
                        color: 'error',
                        text:
                            'Something is wrong. Please contact the administrator.'
                    });
                });
        },
        setMissingDlsAction: async function(shift) {
            const ok = await this.$refs.confirmDialogue.show({
                title:
                    'You want to add the action  "RP - Missing Daily Summary" to this Shift',
                message: 'Are you sure?',
                okButton: 'Yes',
                cancelButton: 'No'
            });
            // If you throw an error, the method will terminate here unless you surround it wil try/catch
            if (ok) {
                var str = this.$store;
                axios
                    .get(
                        'paperwork-analytics/missing-dls/' + shift.ShiftDetail,
                        {
                            headers: {
                                Authorization:
                                    'Bearer ' + this.$store.state.token
                            }
                        }
                    )
                    .then(response => {
                        console.log(response.data);
                        +str.dispatch('setSnackbar', {
                            color: 'success',
                            text: 'Add RP - Missing Daily Summary'
                        });
                        shift.orders.forEach(async element => {
                            const red = await element.actions.findIndex(y => {
                                return y.Action == 'No BOL';
                            });
                            if (red < 0) {
                                element.BolCheckStatusID = 2;
                                element.Status = 'yellow';
                            }
                            let action = {
                                OrderID: element.OrderID,
                                Action: 'RP - Missing Daily Summary',
                                pivot: {
                                    OrderID: element.OrderID,
                                    ActionId: 36
                                }
                            };
                            element.actions.push(action);
                        });
                    })
                    .catch(function(error) {
                        console.log(error);
                        str.state.isLoading = false;
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'Something is wrong. Please contact the administrator.'
                        });
                    });
            }
        },
        lessActionMissingDls: async function(shift) {
            const ok = await this.$refs.confirmDialogue.show({
                title:
                    'You want to delete the action  "RP - Missing Daily Summary" to this Shift',
                message: 'Are you sure?',
                okButton: 'Yes',
                cancelButton: 'No'
            });
            if (ok) {
                var str = this.$store;
                axios
                    .get(
                        'paperwork-analytics/missing-dls/delete/' +
                            shift.ShiftDetail,
                        {
                            headers: {
                                Authorization:
                                    'Bearer ' + this.$store.state.token
                            }
                        }
                    )
                    .then(async response => {
                        console.log(response.data);
                        await shift.orders.forEach(async x => {
                            const idx = await x.actions.findIndex(y => {
                                return y.Action == 'RP - Missing Daily Summary';
                            });
                            // const red = await x.actions.findIndex(y => {
                            //     return y.Action == "No BOL";
                            // });

                            if (idx >= 0) {
                                x.actions.splice(idx, 1);
                                if (x.actions.length == 0) {
                                    x.BolCheckStatusID = 0;
                                    x.Status = 'secondary';
                                }
                                // else{
                                //     if(red >= 0){
                                //         x.BolCheckStatusID = 3;
                                //         x.Status = "red";
                                //     }
                                // }
                            }
                        });
                        this.$store.state.paperworkAnalytics.DailySummay = true;
                        str.dispatch('setSnackbar', {
                            color: 'success',
                            text: 'Delete RP - Missing Daily Summary'
                        });
                    })
                    .catch(function(error) {
                        console.log(error);
                        str.state.isLoading = false;
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'Something is wrong. Please contact the administrator.'
                        });
                    });
            } else {
                this.$store.state.paperworkAnalytics.DailySummay = true;
            }
        },
        closeModal: function() {
            this.showPaperworkAnalyticsPanel = false;
            this.OrderToCheck = [];
            this.pageIndex = 0;
        },
        getShiftCheck: function() {
            this.getOrdersColor();
            var str = this.$store;
            str.state.isLoading = true;
            var parms = {
                StartDate: this.$store.state.getMsk('StartDate'),
                EndDate: this.$store.state.getMsk('EndDate'),
                Color: this.typeColor
            };
            console.log(parms);
            axios
                .post('shift-detail/eleos/check', parms)
                .then(async response => {
                    this.ShiftDetails = response.data;
                    str.state.isLoading = false;
                    console.log(this.ShiftDetails);
                    var drv = response.data.map(x => {
                        return x.Driver;
                    });
                    this.Drivers = this.eliminarDuplicados(drv);
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    str.state.isLoading = false;
                });
        },
        postingShift: function(){
            var str = this.$store;
            str.state.isLoading = true;
            var parms = {
                StartDate: this.$store.state.getMsk('StartDate'),
                EndDate: this.$store.state.getMsk('EndDate'),
                Color: this.typeColor
            };
            console.log(parms);
            axios
                .post('shift-detail/eleos/posted', parms)
                .then(async response => {
                    console.log(response.data);
                    this.getShiftCheck();
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    str.state.isLoading = false;
                });
        },
        getOrdersColor: function() {
            var str = this.$store;
            // str.state.isLoading = true;
            var parms = {
                StartDate: this.$store.state.getMsk('StartDate'),
                EndDate: this.$store.state.getMsk('EndDate')
            };
            axios
                .post('shift-detail/eleos/count', parms)
                .then(async response => {
                    this.colors = response.data;
                    // str.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    // str.state.isLoading = false;
                });
        },
        openPaperworkAnalyticsPanel: async function(orders, i) {
            // Get the NotReviewed value updated
            this.OrderToCheck = orders;
            this.pageIndex = i + 1;
            console.log(this.pageIndex);
            this.showPaperworkAnalyticsPanel = true;
        },
        openPpWEmail: function(itm) {
            if (itm > 1) {
                this.parms.StartDate = this.$store.state.getMsk('StartDate');
                this.parms.EndDate = this.$store.state.getMsk('EndDate');
                this.parms.Status = itm;
                console.log(this.parms);
                this.$store.state.paperworkAnalytics.PpwEmail = true;
            }
        }
    }
};
</script>
<style scoped>
@import '~vue-context/dist/css/vue-context.css';
.tableEloesCheck {
    width: 100%;
}

.tableEloesCheck tr:nth-of-type(odd) {
    background: rgba(0, 0, 0, 0);
}

.timeLoadValue {
    background-color: #ceabab;
    padding: 3px;
    border-radius: 7px;
}
</style>
